export default __webpack_public_path__ + "static/media/promo-table-light.16906cb9.png";